import type { HealthMetric } from '../features/illuminate/api';

export type HealthKitSampleLike = { startDate?: string; endDate?: string };

function sampleTimestamp(sample: HealthKitSampleLike): number {
  return Date.parse(sample.endDate ?? sample.startDate ?? '') || 0;
}

export function selectLatestHealthKitSample<T extends HealthKitSampleLike>(samples: T[]): T | null {
  if (samples.length === 0) return null;
  return samples.reduce((latest, sample) => (
    sampleTimestamp(sample) > sampleTimestamp(latest) ? sample : latest
  ), samples[0]);
}

export async function isHealthKitAvailable(): Promise<boolean> {
  return false;
}

export async function requestHealthPermissions(): Promise<boolean> {
  return false;
}

export async function checkAuthorizationStatus(): Promise<boolean> {
  return false;
}

export async function readLatestHealthData(): Promise<HealthMetric[]> {
  return [];
}
